import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { ReactPlugin } from '@microsoft/applicationinsights-react-js';

const reactPlugin = new ReactPlugin();
let appInsights = null;

export const initializeAppInsights = (config) => {
  if (typeof window === 'undefined') return null; // Next.js SSR guard
  if (appInsights) return appInsights;

  const connectionString = process.env.NEXT_PUBLIC_APP_INSIGHTS_CONNECTION_STRING ||
    'InstrumentationKey=f48e0e52-5628-4ded-a802-6727bb0859c6;IngestionEndpoint=https://southcentralus-3.in.applicationinsights.azure.com/;LiveEndpoint=https://southcentralus.livediagnostics.monitor.azure.com/;ApplicationId=c4c19610-344a-41fa-b996-a3a72219e0a7';

  if (!connectionString) {
    console.warn('Application Insights connection string not found');
    return null;
  }

  appInsights = new ApplicationInsights({
    config: {
      connectionString,
      extensions: [reactPlugin],
      enableAutoRouteTracking: true,
      disableFetchTracking: false,
      enableCorsCorrelation: true,
      enableRequestHeaderTracking: true,
      enableResponseHeaderTracking: true,
    }
  });

  appInsights.loadAppInsights();

  // Set cloud role name to identify this project
  appInsights.addTelemetryInitializer((envelope) => {
    if (envelope.tags) {
      envelope.tags['ai.cloud.role'] = config.cloudRoleName;
      if (config.cloudRoleInstance) {
        envelope.tags['ai.cloud.roleInstance'] = config.cloudRoleInstance;
      }
    }
  });

  appInsights.trackPageView();

  return appInsights;
};

export { reactPlugin, appInsights };
export const getAppInsights = () => appInsights;